
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from 'next-translate/useTranslation';
import { useCallback, useContext } from 'react';
import { twMerge } from 'tailwind-merge';
import { PreviewViewsType, UserContext, } from '@unreserved-frontend-v2/modules/users/components/user-info-provider/user-context';
import { FlexRow } from '@unreserved-frontend-v2/ui/flex/flex-row';
import { FourTilesThickIcon } from '@unreserved-frontend-v2/ui/icons/four-tiles-thick';
import { MapIcon } from '@unreserved-frontend-v2/ui/icons/map';
import { TwoBarsThickIcon } from '@unreserved-frontend-v2/ui/icons/two-bars-thick';
import { ToggleButtonItem, UiToggleButtonGroup, } from '@unreserved-frontend-v2/ui/ui-toggle-button-group/ui-toggle-button-group';
import { ListDisplayType } from './types';
export interface ListDisplayTogglerProps {
    displayType: ListDisplayType;
    onChange: (type: ListDisplayType) => void;
    containerClassName?: string;
    groupHeight?: string;
    forMobile?: boolean;
}
const PREVIEW_ITEM = {
    iconType: 'svg',
    icon: TwoBarsThickIcon,
    value: ListDisplayType.Preview,
    className: 'w-5 flex items-center justify-center',
    svgClassName: '',
    dataTestId: 'toggle-preview',
    label: 'listings:list'
};
const GRID_ITEM = {
    iconType: 'svg',
    icon: FourTilesThickIcon,
    value: ListDisplayType.PreviewGrid,
    className: 'w-5 flex items-center justify-center',
    svgClassName: '',
    dataTestId: 'toggle-preview-grid',
    label: 'listings:tile'
};
const MAP_ITEM = {
    iconType: 'svg',
    icon: MapIcon,
    value: ListDisplayType.Map,
    className: 'w-5 flex items-center justify-center',
    svgClassName: '',
    dataTestId: 'toggle-map',
    label: 'listings:map.map'
};
const DESKTOP_ITEMS = [PREVIEW_ITEM, GRID_ITEM, MAP_ITEM].filter(Boolean) as ToggleButtonItem[];
const MOBILE_ITEMS = [PREVIEW_ITEM, MAP_ITEM] as ToggleButtonItem[];
export function ListDisplayToggler({ displayType, onChange, containerClassName, groupHeight = 'h-8', forMobile = false, }: ListDisplayTogglerProps) {
    const { t } = useTranslation();
    const { setPreviewViewType } = useContext(UserContext);
    const displayToggleItems: ToggleButtonItem[] = forMobile ? MOBILE_ITEMS : DESKTOP_ITEMS;
    const onChangeInternal = useCallback((_: React.MouseEvent<HTMLElement>, newValue: string) => {
        // Call the external handler.
        onChange(newValue as ListDisplayType);
        if (newValue !== ListDisplayType.Map) {
            setPreviewViewType(newValue as PreviewViewsType);
        }
    }, [onChange, setPreviewViewType]);
    return (<FlexRow className={twMerge('mr-[10px] drop-shadow-sm', containerClassName)}>
      <UiToggleButtonGroup data-testid="display-toggler" itemClass={twMerge('flex-row gap-2', groupHeight)} containerClassName={groupHeight} className="bg-white text-xs" value={displayType as string} items={displayToggleItems.map((item) => ({ ...item, label: t(item.label as string) }))} onChange={onChangeInternal} exclusive={true} allowUnselectCurrentValue={false}/>
    </FlexRow>);
}
export default ListDisplayToggler;

    async function __Next_Translate__getServerSideProps__1955d79dfe8__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//[listing]/list-display-toggler',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1955d79dfe8__ as getServerSideProps }
  